import { render, staticRenderFns } from "./menageList.vue?vue&type=template&id=6198f000&scoped=true"
import script from "./menageList.vue?vue&type=script&lang=js"
export * from "./menageList.vue?vue&type=script&lang=js"
import style0 from "./menageList.vue?vue&type=style&index=0&id=6198f000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198f000",
  null
  
)

export default component.exports